import { useCallback, useRef } from 'react';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';
import useAnalysisStore from '../stores/useAnalysisStore';

export const useBroadcast = () => {
  const socket = useSocket();
  const { user } = useAuth();
  const lastBroadcastRef = useRef({});

  return useCallback((tabName) => {
    const currentAnalysis = useAnalysisStore.getState().currentAnalysis;
    if (socket && currentAnalysis?.id && user) {
      const now = Date.now();
      const lastTime = lastBroadcastRef.current[tabName] || 0;
      const debounceTime = tabName === 'context' ? 5000 : 2000;
      if (now - lastTime > debounceTime) {
        lastBroadcastRef.current[tabName] = now;
        socket.emit('analysis_updated', {
          analysisId: currentAnalysis.id,
          user: user,
          tab: tabName
        });
      }
    }
  }, [socket, user]);
};